import { RetrowaveBackground } from "@Src/components/RetrowaveBackground";
import { usePublicMode } from "@Src/contexts/PublicModeContext";
import AppBar from "@Src/layout/AppBar";
import type * as React from "react";
import { Layout, Menu } from "react-admin";

const LayoutComponent = ({
	children,
}: Readonly<{
	children: React.ReactNode;
}>) => {
	const { isPublic } = usePublicMode();

	// No layout for public pages, else we still get padding on the side and top bar etc
	if (isPublic) return <div>{children}</div>;

	return (
		<Layout
			appBar={AppBar}
			menu={Menu}
			// This extra margin is necessary for lists with NullableBooleanInput filter which are a bit larger
			sx={{ "& .RaLayout-appFrame": { mt: 8 } }}
		>
			<RetrowaveBackground />
			{children}
		</Layout>
	);
};

export default LayoutComponent;
